import React from 'react';
import {
  Box,
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Text,
} from '@razorpay/blade/components';
import { useFormWithProvider } from 'forms';

import type { AttendanceSettingsFormState } from 'components/Settings/AttendanceAndLeavesSettings/types';

interface ModifyContractorAttendanceModalProps {
  isOpen: boolean;
  onDismiss: () => void;
}

export const ModifyContractorAttendanceModal = ({
  isOpen,
  onDismiss,
}: ModifyContractorAttendanceModalProps) => {
  const { setFieldValue } = useFormWithProvider<AttendanceSettingsFormState>();

  const handleSave = () => {
    setFieldValue('enableContractorsAttendance', true);
    onDismiss();
  };

  const handleCancelClick = () => {
    onDismiss();
  };

  return (
    <Modal isOpen={isOpen} onDismiss={onDismiss} size="small">
      <ModalHeader title="Track attendance for contractors" />
      <ModalBody>
        <Box display="flex" flexDirection="column" gap="spacing.5">
          <Text size="medium" color="surface.text.gray.muted">
            Contractors will start marking attendance from the next pay cycle. Their invoices will
            show attendance summaries, and configured leave types will be available to them.
          </Text>
          <Text marginTop="spacing.2" size="medium" color="surface.text.gray.muted">
            You can turn this off anytime. Existing records stay intact.
          </Text>
        </Box>
      </ModalBody>
      <ModalFooter>
        <Box
          display="flex"
          justifyContent="flex-end"
          alignItems="center"
          width="100%"
          gap="spacing.5">
          <Button variant="tertiary" onClick={handleCancelClick}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleSave}>
            Track Contractors
          </Button>
        </Box>
      </ModalFooter>
    </Modal>
  );
};
